<div class="rl-card" [class.rl-card--expanded]="expanded">
  <div class="rl-header" (click)="toggleExpansion()">
    <mat-icon class="rl-header__icon">list_alt</mat-icon>
    <div class="rl-header__name">{{ "response-lists.title" | translate }}</div>
    <div class="rl-spacer"></div>
    <!-- A response list is always captured, so this destination is always "set up". -->
    <span class="rl-header__active">
      <mat-icon class="rl-header__status">check</mat-icon>
      {{ "campaign.widget.sidebar.form-settings-v2.active-badge" | translate }}
    </span>
    <mat-icon class="rl-chevron">{{ expanded ? "expand_less" : "expand_more" }}</mat-icon>
  </div>

  @if (expanded) {
    <div class="rl-body" @expandReveal>
      <mat-radio-group class="rl-radios" [(ngModel)]="responseListAction" (change)="onActionChange()">
        <mat-radio-button [value]="'new'">
          {{ "campaign.widget.sidebar.form-settings.create-new-list" | translate }}
        </mat-radio-button>

        <div class="rl-existing">
          <mat-radio-button
            [value]="'existing'"
            [disabled]="!responseLists?.length"
            [matTooltip]="'campaign.widget.sidebar.form-settings.no-existing' | translate"
            [matTooltipDisabled]="!!responseLists?.length">
            {{ "campaign.widget.sidebar.form-settings.use-existing-list" | translate }}
          </mat-radio-button>
          <app-response-list-selector
            class="rl-selector"
            [class.rl-not-chosen]="selectedResponseListNotChosen"
            [items]="responseLists"
            [value]="selectedResponseListId"
            [disabled]="responseListAction === 'new' || !responseLists?.length"
            [placeholder]="!responseLists?.length ? ('response-lists.no-lists' | translate) : ''"
            (selectionChange)="onSelectorChange($event)"></app-response-list-selector>
        </div>
      </mat-radio-group>

      <div class="rl-explainer">
        <mat-icon>help_outline</mat-icon>
        <span>{{ "response-lists.description" | translate }}</span>
      </div>

      <div class="rl-actions">
        <button mat-stroked-button class="secondary-button" (click)="collapse()">
          {{ "generic.cancel" | translate | uppercase }}
        </button>
        <button mat-stroked-button class="primary-button" [disabled]="saving" (click)="save()">
          @if (saving) {
            <mat-spinner class="rl-spinner" diameter="18" mode="indeterminate"></mat-spinner>
          } @else {
            {{ "generic.save" | translate | uppercase }}
          }
        </button>
      </div>
    </div>
  }
</div>
